import React from 'react';

export const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
};
